import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';

import './styles.css';

const OneOffChargesScheduleExtraOptions = ({
  openCreateCreditNoteModal,
  openCreateInvoiceModal,
  openCreateDraftInvoiceModal,
  openCreateOverpaymentModal,
  openOneOffChargeModal,
  scheduleType,
  scheduleId
}) => (
  <div className="OneOffChargesScheduleExtraOptions">
    <ButtonDropdown title="Schedule options" className="scheduleOptions">
      <ButtonDropdown.Option
        onClick={() => openCreateInvoiceModal(scheduleType)}>
        Create an invoice
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        onClick={() => openCreateDraftInvoiceModal(scheduleType, scheduleId)}>
        Create a draft invoice
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        onClick={() => openCreateCreditNoteModal(scheduleType)}>
        Create a credit note
      </ButtonDropdown.Option>
      <ButtonDropdown.Option
        onClick={() => openCreateOverpaymentModal(scheduleType)}>
        Create an overpayment
      </ButtonDropdown.Option>
      <ButtonDropdown.Option onClick={() => openOneOffChargeModal()}>
        Create charge
      </ButtonDropdown.Option>
    </ButtonDropdown>
  </div>
);

export default OneOffChargesScheduleExtraOptions;
